<template>
  <div
    class="fixed top-0 left-0 w-screen h-screen z-[100001] opacity-0 pointer-events-none transition-all duration-500"
    :class="{ 'opacity-100 pointer-events-auto': modalsStore.isConfirmationModalVisible }"
    data-testid="global-confirmation-modal">
    <div
      class="absolute top-0 left-0 w-full h-full z-10 opacity-70 bg-black backdrop-blur-lg"
      @click="modalsStore.incrementConfirmationModalAnswerCounter(false)"></div>
    <div
      class="absolute inset-0 z-20 flex items-center justify-center p-5 pointer-events-none">
      <div
        class="relative w-full max-w-xl max-h-full scale-0 overflow-y-auto rounded-2xl bg-white pointer-events-auto transition-all duration-500"
        :class="{ 'scale-100': modalsStore.isConfirmationModalVisible }">
        <div class="w-full p-6 flex flex-col items-center justify-center gap-4">
          <div
            class="modal-message w-full font-semibold text-xl text-center"
            v-html="modalsStore.confirmationCustomMessage ? modalsStore.confirmationCustomMessage : 'Are you sure?'"></div>
          <div class="w-full flex items-center justify-center gap-4">
            <button
              class="w-44 h-9 flex items-center justify-center cursor-pointer rounded bg-base-color hover:bg-dark-base-color text-white tr-all"
              @click="modalsStore.incrementConfirmationModalAnswerCounter(true)">
              {{ modalsStore.isConfirmationModalRejectButtonHidden ? 'Ok' : 'Yes' }}
            </button>
            <button
              v-if="!modalsStore.isConfirmationModalRejectButtonHidden"
              class="w-44 h-9 flex items-center justify-center cursor-pointer rounded bg-gray hover:bg-gray text-white tr-all"
              @click="modalsStore.incrementConfirmationModalAnswerCounter(false)">
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useModalsStore from '@/store/modals';

const modalsStore = useModalsStore();
</script>
